
  import { css } from 'lit';
  export const styles = css`:host{--outline-color: var(--ig-card-outline-color, var(--ig-gray-200));--border-radius: var(--ig-card-border-radius, clamp(0rem, calc(var(--ig-radius-factor, 0) * 1.5rem), 1.5rem));--ig-theme: fluent;--ig-theme-variant: light}`;
  